import React, {Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';


import theme from '../../theme';

import toast from "../../../utils/ToasterService";
import { SidebarItem } from '../../components/Sidebar';
import { SidebarContent, SidebarHeader, SidebarHeaderDialog } from './Sidebar/Sidebar';
import UserIcon from '../../assets/userSVG';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';;
import IconButton from '@mui/material/IconButton/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AttentionIcon from '@mui/icons-material/ReportProblem';
import log from 'loglevel'
import {
  getBitValueFromByteArray,
  isThereAnErrorMsg,
  parseErrorMsgToNiceText,
  kdtimeToYDHMobject,
  getGatewayFirmwareVersionNumeric
} from '../../../utils/elsc_utils'
import {t} from 'i18next'
import {Trans} from 'react-i18next'

const styles = {
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    display: 'flex',
    height: '100%',
  },
  cardWrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    msMaxWidth: '80%',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'center',
    },
  },
  cardsTitle: {
    position: 'absolute',
    padding: '20px 0 18px 0',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '-7px',
    },
  },
  cards: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    paddingTop: theme.spacing.unit * 8,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardTitle: {
    paddingBottom: 20,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  cardItems: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  // view specific
  SidebarItemCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  user: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  userDelete: {
    fontWeight: 600,
    lineHeight: 2,
    color: theme.palette.error.dark,
    marginBottom: 20,
  },
  deviceSpecsRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  deviceSpecsRowItem: {
    marginRight: 30,
  },
  fabButton: {
    position: 'absolute',
    bottom: theme.spacing.unit * 3,
    right: theme.spacing.unit * 6,
  },
  textFieldFormLabel: {
    '&$textFieldFocused': {
      color: theme.palette.primary.dark,
    },
  },
  textFieldFocused: {},
  textFieldUnerline: {
    '&:after': {
      borderBottomColor:theme.palette.primary.dark,
    },
  },

}
  


class DeviceInformation extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            view: 'device',
            updated: false,
            device: {
                label: this.props.device.label,
                user: this.props.device.user,
            },
            sensorValues: {
              rf: -1,
              co2: -1,
              ti: -55,
              ta: -55
            },
            messages : {
              current_val: "Keine Meldung",
              last_val: "Keine Meldung",
              current_act: false,
              last_act: false,
              last_time: "00:00",
              last_date: "01.01.14"
            },
            uptime : {
              years: 0,
              days: 0,
              hours: 0,
              minutes: 0,
            },
            specs: {
              gateway :{
                articlecode : "CEW0037E10A",
                id: "000000",
                firmware_version: "1.0.0"
              },
              controlsystem: {
                articlecode_ctrl: "SWZ0021E10A",
                articlecode_tft_1: "ETA0032E10A",
                articlecode_tft_2: "ETA0032E10A",
                articlecode_tft_3: "ETA0032E10A"
              },
            }
        }
    }
    static propTypes = {
      device: PropTypes.shape({}),
      isActive: PropTypes.bool,
      onActivate: PropTypes.func.isRequired,
      onSave: PropTypes.func.isRequired,
      onClose: PropTypes.func.isRequired,
    }

    static defaultProps = {
      device: {},
      isActive: false,
    }

  componentWillMount() {
    if (this.props.deviceVarList) {
      this.setState({
        sensorValues: {
          rf_act: getBitValueFromByteArray(12, "string", this.props.deviceVarList.id_48),
          co2_act: getBitValueFromByteArray(13, "string", this.props.deviceVarList.id_48),
          ti_act: getBitValueFromByteArray(15, "string", this.props.deviceVarList.id_48),
          ta_act: getBitValueFromByteArray(14, "string", this.props.deviceVarList.id_48),
          rf_val: this.props.deviceVarList.id_171,
          co2_val: this.props.deviceVarList.id_172,
          ti_val: this.props.deviceVarList.id_169,
          ta_val: this.props.deviceVarList.id_170,
        },
        messages:
        {
          current_val: parseErrorMsgToNiceText(this.props.deviceVarList.id_9),
          last_val: parseErrorMsgToNiceText(this.props.deviceVarList.id_19),
          current_act: isThereAnErrorMsg(this.props.deviceVarList.id_9),
          last_act: isThereAnErrorMsg(this.props.deviceVarList.id_19),
          last_time: this.props.deviceVarList.id_21 ? this.props.deviceVarList.id_21.substr(0, 5) : "",
          last_date: this.props.deviceVarList.id_20 ? this.props.deviceVarList.id_20 : "",
        },
        uptime: kdtimeToYDHMobject(this.props.deviceVarList.id_168),
        specs: {
          gateway: {
            articlecode: this.props.gateWayData.articlecode,
            id: this.props.gateWayData.id,
            firmware_version: this.props.gateWayData.fw_version,
          },
          controlsystem: {
            articlecode_ctrl: this.props.deviceVarList.id_3,
            articlecode_tft_1: this.props.deviceVarList.id_10,
            articlecode_tft_2: this.props.deviceVarList.id_13,
            articlecode_tft_3: this.props.deviceVarList.id_16,
          },
        }
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    log.debug("NEXTPROPS: ", nextProps)
    if (nextProps.deviceVarList) {
      this.setState({
        // ...this.state,
        sensorValues: {
          rf_act: getBitValueFromByteArray(12, "string", nextProps.deviceVarList.id_48),
          co2_act: getBitValueFromByteArray(13, "string", nextProps.deviceVarList.id_48),
          ti_act: getBitValueFromByteArray(15, "string", nextProps.deviceVarList.id_48),
          ta_act: getBitValueFromByteArray(14, "string", nextProps.deviceVarList.id_48),
          rf_val: nextProps.deviceVarList.id_171,
          co2_val: nextProps.deviceVarList.id_172,
          ti_val: nextProps.deviceVarList.id_169,
          ta_val: nextProps.deviceVarList.id_170,
        },
        messages:
        {
          current_val: parseErrorMsgToNiceText(nextProps.deviceVarList.id_9),
          last_val: parseErrorMsgToNiceText(nextProps.deviceVarList.id_19),
          current_act: isThereAnErrorMsg(nextProps.deviceVarList.id_9),
          last_act: isThereAnErrorMsg(nextProps.deviceVarList.id_19),
          last_time: nextProps.deviceVarList.id_21 ? nextProps.deviceVarList.id_21.substr(0, 5) : "",
          last_date: nextProps.deviceVarList.id_20 ? nextProps.deviceVarList.id_20 : "",
        },
        uptime: kdtimeToYDHMobject(nextProps.deviceVarList.id_168),
        specs: {
          gateway: {
            articlecode: nextProps.gateWayData.articlecode,
            id: nextProps.gateWayData.id,
            firmware_version: nextProps.gateWayData.fw_version,
          },
          controlsystem: {
            articlecode_ctrl: nextProps.deviceVarList.id_3,
            articlecode_tft_1: nextProps.deviceVarList.id_10,
            articlecode_tft_2: nextProps.deviceVarList.id_13,
            articlecode_tft_3: nextProps.deviceVarList.id_16,
          },
        }
      })
    }
  }

    componentDidMount(){
      log.debug(this.state)
      log.debug(this.props)
      getGatewayFirmwareVersionNumeric(this.state.specs.gateway.firmware_version)
      // KDtimeToYDHMobject(this.props.deviceVarList.id_168)
    }


    componentWillUpdate (nextProps, nextState) {
      if (nextProps.device && nextProps.device.id !== this.props.device.id ) {
        this.setState({
          view: 'device',
          updated: false,
          device: {
            label: nextProps.device.label,
            user: nextProps.device.user,
          },
          
        });  
      }
    }

    setView (view) {
      this.setState({ view });
    }

    handleChangeValue = name => event => {
      this.setState({
        updated: event.target.value !== this.props.device[name],
        device: { [name]: event.target.value.slice(0, 24) }
      });
    };

    handleSave = () => {
      log.debug("HANDLE SAVE", this.props.device.deviceid,  this.state.device.label)
      this.props.onSave(this.props.device.deviceid,  this.state.device.label);
      this.props.onMyload()
    }

    handleRequestActivate = () => {
      log.debug("handleRequestActivate")
      this.setView('requestactivate');
      this.props.onMyload()
    }

    handleRequestDeleteDevice = () => {
        log.debug("handleRequestDeleteDevice")
        this.setView('requestdeletedevice');
        this.props.onMyload()
        
    }

    handleDeleteAssignment = (userId ) => {
        //log.debug("userud", userId)
        this.props.onDeleteAssignment(this.props.device.deviceid, userId, () => {
            for(var i = 0; i< this.state.device.user.length; i++) {
                log.debug(this.state.device.user[i])
                if(this.state.device.user[i]._id === userId) {
                    this.state.device.user.splice(i, 1);
                    this.setState(this.state);
                }
            }
        });
    }

    handleActivate = () => {
      log.debug("handleActivate", this.props.device)
      this.props.onActivate(this.props.device.id);
      const id = this.props.device.deviceid.replace("esp32_","");
      toast.success(t('DeviceInformation.toast_device_activation_success_01') + id + t('DeviceInformation.toast_device_activation_success_02'));
      this.setView('device');
      this.props.onClose()
    }

    handleDeleteDevice = () => {
      this.props.onDeleteDevice(this.props.device.deviceid);
      const id = this.props.device.deviceid.replace("esp32_","");
      toast.success(t('DeviceInformation.toast_device_deletion_success_01') + id + t('DeviceInformation.toast_device_deletion_success_02'));
      this.setView('device');
      this.props.onClose();
  }

    handleRequestDeleteUser = () => {
      this.setView('requestdeleteuser');
    }

    handleDeleteUser = () => {
      log.debug('delete user');
      this.props.onSave({
        id: this.props.device.id,
        user: this.state.device.user,
      });
    }



    renderRequestActivate () {
      const { classes } = this.props;
      return (
        <Fragment>
          <SidebarHeaderDialog
            title={t('DeviceInformation.sidebar_header_dialog_devices_title')}
            onClose={this.props.onClose}
            onAction={this.handleActivate}
          />
          <SidebarContent>
            <SidebarItem>
              <Typography style={styles.userDelete} color="error">
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_activation_hint"></Trans> 
              </Typography>
              <Typography style={styles.userDelete}>
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_activation_text_01"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_activation_text_02"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_activation_text_03"></Trans>
              </Typography>
            </SidebarItem>
          </SidebarContent>
        </Fragment>
      );
    }

    renderRequestDeleteDevice () {
      const { classes } = this.props;
      return (
        <Fragment>
          <SidebarHeaderDialog
            title={t('DeviceInformation.sidebar_header_dialog_devices_title')}
            onClose={this.props.onClose}
            onAction={this.handleDeleteDevice}
          /> 
          <SidebarContent>
            <SidebarItem>
              <Typography style={{...styles.userDelete, marginTop:10}} color="error">
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_device_deletion_caution"></Trans>
              </Typography>
              <Typography style={styles.userDelete}>
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_device_deletion_text_01"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_device_deletion_text_02"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_device_deletion_text_03"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_device_deletion_text_04"></Trans>
              </Typography>
            </SidebarItem>
          </SidebarContent>
        </Fragment>
      );
    }

    renderRequestDeleteUser () {
      const { classes } = this.props;
      return (
        <Fragment >
          <SidebarHeaderDialog
            title={t('DeviceInformation.sidebar_header_dialog_user_deletion_title')}
            onClose={this.props.onClose}
            onAction={this.handleDeleteUser}
          />
          <SidebarContent>
            <SidebarItem>
              <Typography style={styles.userDelete} color="error">
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_user_deletion_caution"></Trans>
              </Typography>
              <Typography style={styles.userDelete}>
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_user_deletion_text_01"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_user_deletion_text_02"></Trans>
                {' '}
                <br />
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_user_deletion_text_03"></Trans>
              </Typography>
              <Typography style={styles.userDelete}>
              <Trans i18nKey="DeviceInformation.sidebar_header_dialog_user_deletion_text_04"></Trans>
              </Typography>
            </SidebarItem>
          </SidebarContent>
        </Fragment>
      );
    }

  renderUsers = () => {
    const { classes } = this.props;

    var users = [];
    if (this.state.device.user) {
      users = this.state.device.user;
      for (var i = 0; i < users.length; i++) {
        if (this.props.currentUser._id === users[i]._id) {
          users.splice(0, 0, users.splice(i, 1)[0]);
        }
      }
    }


    return (
      <div>
        <Typography variant="subtitle1"><Trans i18nKey="DeviceInformation.sidebar_users_section_subheading"></Trans></Typography>
        <Typography variant="caption"><Trans i18nKey="DeviceInformation.sidebar_users_section_caption"></Trans></Typography>
        <div style={styles.SidebarItemCol}>
          {users && users.map((user, k) => (
            <div style={styles.user} key={user.email}>
              <Typography variant="body2">{user.email}</Typography>
              {(0 === k) ?
                <IconButton key={"user-" + k}>
                  <Link to={"/profile"} style={{ textDecoration: 'none' }}>
                    <UserIcon color={theme.palette.primary.dark} marginRight={false} />
                  </Link>
                </IconButton> : null}
              {(0 !== k) ?
                <IconButton onClick={() => this.handleDeleteAssignment(user._id)} key={"user-" + k}>
                  <DeleteIcon color={theme.palette.primary.dark} />
                </IconButton> : null}

            </div>
          ))}
        </div>
      </div>

    );
  }

    renderSensorValues () {
      const { classes } = this.props;
      return (
        <div>
          <Typography
            variant="subtitle1">
              <Trans i18nKey="DeviceInformation.sidebar_sensors_section_subheading"></Trans>
          </Typography>
           <Typography
            variant="caption"
            style={{ textAlign: 'left' }}
            gutterBottom>
           <Trans i18nKey="DeviceInformation.sidebar_sensors_section_caption"></Trans>
           </Typography>
            <div style={styles.deviceSpecsRow}>
              <span style={styles.deviceSpecsRowItem}>
                <Typography gutterBottom
                  variant="body1"
                  style={{ textAlign: 'center' }}
                  >
                  <Trans i18nKey="DeviceInformation.sidebar_sensors_section_relative_humidity"></Trans>
                </Typography>
                <Typography variant="caption" style={{ textAlign: 'center' }}>
                  {(this.state.sensorValues && this.state.sensorValues.rf_act !== false)
                    ? `${this.state.sensorValues.rf_val} %` : t('DeviceInformation.sidebar_sensors_section_no_sensor')
                  }
                </Typography>
              </span>
              <span style={styles.deviceSpecsRowItem}>
                <Typography
                  variant="body1"
                  style={{ textAlign: 'center' }}
                  gutterBottom
                >CO2
                </Typography>
                <Typography variant="caption" style={{ textAlign: 'center' }}>
                  {(this.state.sensorValues && this.state.sensorValues.co2_act !== false)
                    ? `${this.state.sensorValues.co2_val} ppm`: t('DeviceInformation.sidebar_sensors_section_no_sensor')
                  }
                </Typography>
              </span>
              <span style={styles.deviceSpecsRowItem}>
                <Typography
                  variant="body1"
                  style={{ textAlign: 'center' }}
                  gutterBottom
                >Ti
                </Typography>
                <Typography variant="caption" style={{ textAlign: 'center' }}>
                  {(this.state.sensorValues && this.state.sensorValues.ti_act !== false)
                    ? `${this.state.sensorValues.ti_val} °C`: t('DeviceInformation.sidebar_sensors_section_no_sensor')
                    }
                </Typography>
              </span>
              <span style={styles.deviceSpecsRowItem}>
                <Typography
                  variant="body1"
                  style={{ textAlign: 'center' }}
                  gutterBottom
                >Ta
                </Typography>
                <Typography variant="caption" style={{ textAlign: 'center' }}>
                  {(this.state.sensorValues && this.state.sensorValues.ta_act !== false)
                    ? `${this.state.sensorValues.ta_val} °C`: t('DeviceInformation.sidebar_sensors_section_no_sensor')
                  }
                </Typography>
              </span>
            </div>
            </div>
          
      );
    }

  renderMessages() {
    return (
      <div>
        <Typography
          variant="subtitle1">
          <Trans i18nKey="DeviceInformation.sidebar_messages_section_subheading"></Trans>
        </Typography>
        <Typography
          variant="caption"
          style={{ textAlign: 'left' }}
          gutterBottom>
          <Trans i18nKey="DeviceInformation.sidebar_messages_section_caption"></Trans>
        </Typography>


        <span>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="body1"
              color={(this.state.messages && (this.state.messages.current_act === true)) ? 'error' : 'default'}
            >
              <Trans i18nKey="DeviceInformation.sidebar_messages_section_text_actual"></Trans>
            </Typography>
            {(this.state.messages && (this.state.messages.current_act === true))
              && (
                <AttentionIcon
                  style={{
                    fill: theme.palette.custom.warning,
                    position: 'relative',
                    left: '15px',
                    top: '-3px',
                  }}
                />
              )}

          </div>
          <Typography
            variant="caption"
            style={(this.state.messages && (this.state.messages.current_act === true)) ? {} : { color: theme.palette.primary.dark }}
            color={(this.state.messages && (this.state.messages.current_act === true)) ? 'error' : 'primary'}
            gutterBottom>
            {this.state.messages.current_val}
          </Typography>
          {/* <br/> */}
        </span>

        <span>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" >
              <Trans i18nKey="DeviceInformation.sidebar_messages_section_text_last"></Trans>
            </Typography>
          </div>
          <Typography
            style={{ color: theme.palette.primary.dark }}
            variant="caption"
            color={(this.state.messages && (this.state.messages.last_act === true)) ? 'primary' : 'primary'}>
            {this.state.messages.last_date && (this.state.messages.last_date + "    ")}
            {this.state.messages.last_time}
            {(this.state.messages.last_time || this.state.messages.last_date) && <br />}
            {this.state.messages.last_val}
          </Typography>
        </span>
      </div>
    );
  }

  renderUptime() {
    const { classes } = this.props;

    return (

      <div>
        <Typography
          variant="subtitle1">
          <Trans i18nKey="DeviceInformation.sidebar_uptime_section_subheading"></Trans>
        </Typography>
        <Typography
          variant="caption"
          style={{ textAlign: 'left' }}
          gutterBottom>
          <Trans i18nKey="DeviceInformation.sidebar_uptime_section_caption"></Trans>
        </Typography>
        <div style={styles.deviceSpecsRow}>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_uptime_section_text_years"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.uptime.years}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_uptime_section_text_days"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.uptime.days}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_uptime_section_text_hours"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.uptime.hours}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_uptime_section_text_minutes"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.uptime.minutes}
            </Typography>
          </span>
        </div>
      </div>

    );
  }

  renderGatewaySpecs() {
    const { classes } = this.props;
    return (
      <div>
        <Typography variant="subtitle1">
          <Trans i18nKey="DeviceInformation.sidebar_gateway_specs_section_subheading"></Trans>
        </Typography>
        <Typography variant="caption" gutterBottom>
          <Trans i18nKey="DeviceInformation.sidebar_gateway_specs_section_caption"></Trans>
        </Typography>
        <div style={styles.deviceSpecsRow}>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_gateway_specs_section_article_code"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.specs.gateway.articlecode ? this.state.specs.gateway.articlecode : "----------"}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_gateway_specs_section_device_id"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.specs.gateway.id ? this.state.specs.gateway.id : "------"}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_gateway_specs_section_firmware"></Trans>
            </Typography>
            <Typography variant="caption" gutterBottom style={{ textAlign: 'center' }}>
              {this.state.specs.gateway.firmware_version ? this.state.specs.gateway.firmware_version : "-----"}
            </Typography>
          </span>
        </div>
      </div>
    );
  }

  renderDeviceSpecs() {
    const { classes } = this.props;
    return (


      <div>
        <Typography variant="subtitle1">
          <Trans i18nKey="DeviceInformation.sidebar_device_specs_section_subheading"></Trans>
        </Typography>
        <Typography variant="caption" gutterBottom>
          <Trans i18nKey="DeviceInformation.sidebar_device_specs_section_caption"></Trans>
        </Typography>
        <br />
        <div style={styles.deviceSpecsRow}>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>
              <Trans i18nKey="DeviceInformation.sidebar_device_specs_section_control"></Trans>
            </Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.specs.controlsystem.articlecode_ctrl ? (this.state.specs.controlsystem.articlecode_ctrl.includes("---", 0) ? t('DeviceInformation.sidebar_device_specs_section_bde_not_connected') : this.state.specs.controlsystem.articlecode_ctrl) : t('DeviceInformation.sidebar_device_specs_section_bde_not_connected')}
            </Typography>
            <br />
          </span>
        </div>
        <div style={styles.deviceSpecsRow}>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>TFT-Touch-BD1</Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.specs.controlsystem.articlecode_tft_1 ? (this.state.specs.controlsystem.articlecode_tft_1.includes("---", 0) ? t('DeviceInformation.sidebar_device_specs_section_bde_not_connected') : this.state.specs.controlsystem.articlecode_tft_1) : t('DeviceInformation.sidebar_device_specs_section_bde_not_connected')}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>TFT-Touch-BD2</Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.specs.controlsystem.articlecode_tft_2 ? (this.state.specs.controlsystem.articlecode_tft_2.includes("---", 0) ? t('DeviceInformation.sidebar_device_specs_section_bde_not_connected') : this.state.specs.controlsystem.articlecode_tft_2) : t('DeviceInformation.sidebar_device_specs_section_bde_not_connected')}
            </Typography>
          </span>
          <span style={styles.deviceSpecsRowItem}>
            <Typography variant="body1" gutterBottom>TFT-Touch-BD3</Typography>
            <Typography variant="caption" style={{ textAlign: 'center' }}>
              {this.state.specs.controlsystem.articlecode_tft_3 ? (this.state.specs.controlsystem.articlecode_tft_3.includes("---", 0) ? t('DeviceInformation.sidebar_device_specs_section_bde_not_connected') : this.state.specs.controlsystem.articlecode_tft_3) : t('DeviceInformation.sidebar_device_specs_section_bde_not_connected')}
            </Typography>
          </span>
        </div>
      </div>
    )
  }

  renderViewHeader() {
    if (this.state.updated === true) {
      return (
        <SidebarHeaderDialog
          title={t('DeviceInformation.sidebar_header_dialog_devices_title')}
          onClose={this.props.onClose}
          onAction={this.handleSave}
        />
      );
    }
    return (
      <SidebarHeader
        title={t('DeviceInformation.sidebar_header_dialog_devices_title')}
        onClose={this.props.onClose}
      />
    );
  }

  renderDevicesInfos() {
    return (
      this.props.isActive &&
      <SidebarItem>
        <Typography variant='h5'>
          <Trans i18nKey="DeviceInformation.sidebar_control_header"></Trans>
        </Typography>
        <br />
        {this.renderDeviceSpecs()}
        <br />
        {this.renderMessages()}
        <br />
        {this.renderSensorValues()}
        <br />
        {this.renderUptime()}
      </SidebarItem>

    )
  }

  renderGatewayInfos(props) {

    const { classes } = props
    log.debug(classes)
    return (

      <SidebarItem divider={this.props.isActive} color='#2D727F'>
        <Typography variant='h5'>
          <Trans i18nKey="DeviceInformation.sidebar_control_header"></Trans>
        </Typography>
        <TextField
          /* InputProps={{
            classes: {
              underline: styles.textFieldUnerline
            },
          }}
          InputLabelProps={{
            FormLabelClasses: {
              root: styles.textFieldFormLabel,
              focused: styles.textFieldFocused,
            },
          }} */

          sx={{
            fieldset: { borderColor: "red" }
          }}

          label="Name"
          margin="normal"
          variant='standard'
          value={this.state.device.label}
          onChange={this.handleChangeValue('label')}
        />
        <br></br>
        <br></br>
        {this.renderUsers()}
        <br></br>


        <Typography variant='subtitle1'>
          <Trans i18nKey="DeviceInformation.sidebar_gateway_subheading"></Trans>
        </Typography>
        <Typography variant='caption'><Trans i18nKey="DeviceInformation.sidebar_gateway_title"></Trans></Typography>
        <br></br>
        {!this.props.isActive
          ?
          <Button
            color="primary"
            onClick={this.handleRequestActivate}
            disabled={this.props.isActive}
            // style={{ padding: 0}}
            style={{ color: theme.palette.primary.dark, padding: 0 }}
          >
            <Trans i18nKey="DeviceInformation.button_gateway_activate"></Trans>
          </Button>
          :
          <Button
            color="primary"
            disabled={this.props.isActive}
            style={{ color: theme.palette.primary.dark, padding: 0 }}
          >
            <Trans i18nKey="DeviceInformation.button_gateway_activated"></Trans>
          </Button>
        }

        <br></br>

        {this.props.isActive && this.renderGatewaySpecs()}
        <br></br>

        <Typography variant='subtitle1'>
          <Trans i18nKey="DeviceInformation.sidebar_gateway_subheading_delete"></Trans>
        </Typography>
        <Typography variant='caption'>
          <Trans i18nKey="DeviceInformation.sidebar_gateway_caption_delete"></Trans>
        </Typography>
        <br></br>
        <Button
          variant='outlined'
          color="primary"
          onClick={this.handleRequestDeleteDevice}
          style={{ color: theme.palette.primary.dark, padding: 10 }}

        >
          <Trans i18nKey="DeviceInformation.button_gateway_delete_delete"></Trans>
        </Button>

      </SidebarItem>
    )
  }

    renderView () {
        log.debug("render View")
        log.debug(this.state)
      return (
        <Fragment>
          {this.renderViewHeader()}
          <SidebarContent>
            {this.renderGatewayInfos(this.props)}
            {this.renderDevicesInfos()}  
          </SidebarContent>
        </Fragment>
      );
    }

    render () {
      log.debug(this.props)
      switch (this.state.view) {
        case 'requestdeleteuser':
          return this.renderRequestDeleteUser();
        case 'requestactivate':
          return this.renderRequestActivate();
        case 'requestdeletedevice':
          return this.renderRequestDeleteDevice();
        case 'device':
        default:
          return this.renderView();
      }
    }
}

export default DeviceInformation;
